<template>
  <div>
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content">
        <el-form ref="form" :model="form" label-width="100px" :rules="rules" class="bill-info-form" :label-position="'top'">
          <el-row>
            <el-col :span="12">
              <div class="bill-info">
                <el-form-item prop="name">
                  <template slot="label">
                    <div class="bill-info-title">商户名称</div>
                  </template>
                  <el-input v-model="form.name" />
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="bill-info">
                <el-form-item prop="alias_name">
                  <template slot="label">
                    <div class="bill-info-title">别名</div>
                  </template>
                  <el-input v-model="form.alias_name" />
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="bill-info">
                <el-form-item prop="url">
                  <template slot="label">
                    <div class="bill-info-title">域名（已备案）</div>
                  </template>
                  <el-input v-model="form.url"/>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="logo" class="bill-info">
                <template slot="label">
                  <div class="mail-info-title">logo上传：</div>
                </template>
                <upload-file
                  class="upload-contract"
                  @remove_file="handleRemoveFile"
                  @return_url="handUploadFile"
                  @before_upload="beforeUpload"
                  :title="'业务清单'"
                  :multiple="'false'"
                  :multiSelection="false"
                  :dir="'bill'"
                  :selectfiles="'importExcel'"
                  :postfiles="'submitImportExcel'"
                  :ossfile="'ossExcelFile'"
                  ref="uploadImg"
                  :max_width="1000"
                  :max_height="1000"
                  :fileUrl="dataOemUrl"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row class="save-btn-wrapper">
          <el-button type="primary" size="medium" @click="saveClick('form')">保存</el-button>
        </el-row>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import UploadFile from "@/components/UploadFile";
export default {
  components: {
    PageHeaderLayout,
    UploadFile
  },
  data() {
    return {
      dataOemUrl: '',
      dialogData:{
        visible: false,
        title: '',
        width: '40%',
        loading: false,
        modal: false
      },
      form: {
        name: "",
        alias_name: "",
        url: "",
        logo: ""
      },
      rules: {
        name: [
          { required: true, message: '请输入商户名称', trigger: 'blur' }
        ],
        alias_name: [
          { required: true, message: '请输入商户别名', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请输入域名', trigger: 'blur' }
        ],
        logo: [
          { required: true, message: '请上传logo', trigger: 'blur' }
        ],
      },

    };
  },
  methods: {
    //上传文件前的回调
    beforeUpload(load_text) {
      console.log("load_text",load_text)
      this.dialogData.loading = true;
    },
     // 删除文件回调
    handleRemoveFile() {
      console.log("->删除成功....");
    },
    // 上传文件成功回调
    handUploadFile({url, filename, load_text, title}) {
      console.log("->上传成功....", url, filename, load_text, title);
      this.form.logo = url
      this.dataOemUrl = url
      this.dialogData.loading = false
    },
    // 保存
    saveClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.$route.query.id) {
            this.updateOem()
          }else {
            this.formSubmit()
          }
        } else {
          this.$message.warning('请先正确填写信息');
          return false;
        }
      });
    },
    //创建oem
    async formSubmit() {
      let result = await this.$api.createOem(this.form)
      if(result) {
        this.$router.push({path:'/oem'})
      }
    },
    //编辑oem
    async updateOem() {
      let args = this.form
      let result = await this.$api.updateOem(this.$route.query.id, args)
      if(result) {
        this.$router.push({path:'/oem'})
      }
    },
  },
  mounted() {
    if(this.$route.query.id) {
      this.form = this.$route.query
      this.dataOemUrl = this.$route.query.logo
    }
  },
};
</script>

<style lang="stylus" scoped>
  .address-select
    width: 85%
  .manage-bill-btn
    margin-left: 20px
  .bill-info-form
    margin-top: 40px
  .bill-info
    display: flex
    flex-direction: column
    width: 90%
    height: 80px
    padding: 20px 0
  .bill-info-title
    width:100%
  .bill-mail-info
    width: 70%
    max-width: 600px;
    margin: 0px auto
    margin-top: 40px
    padding: 0 25%
    padding-top: 50px
    padding-bottom: 20px
    border-top: 1px solid #dcdfe6
    border-bottom: 1px solid #dcdfe6
  /deep/.bill-mail-info .el-form-item
    display: flex
    flex-direction: row
  /deep/.el-form--label-top .el-form-item__label
    position: relative
  /deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before,
  /deep/.el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap > .el-form-item__label:before
    position: absolute
    left: -10px
  /deep/.bill-mail-info .el-form-item .el-form-item__content
    width: 100%
  .mail-info-title
    width: 100px
  .business-address
    display: flex
  .save-btn-wrapper
    display: flex
    justify-content: flex-end
    margin-top: 30px
    margin-bottom: 30px
  .priceIcon
    font-size: 30px
    color: #e6a23c
    margin-top: 3px
    margin-left: 10px
  .alert
    margin-top: 40px
  .icon
    font-size: 30px
  .fenge
    border-top: 1px solid #dcdfe
    margin-top: 50px
    padding-top: 30px
    width: 99%
</style>






